import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 登入 - 手機號碼查詢及發送 OTP 簡訊
 */
const LoginQueryMobile = [
    'POST',
    RouteUrlList.API_LoginQueryMobile.path,
    {},
    200,
    {
        status: true,
        title: '查詢成功',
        message: '已發送驗證碼至您的手機',
        errorCode: '',
        mobile: '0912***678',
        code: 0,
        letter: 'OTP 驗證碼已發送',
        isInWaitToSendAgain: false,
        dayLimit: 5,
        times: 1
    }
];

export default LoginQueryMobile;
